import {FinancingCompositionScene} from '@dms/api/shared';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {LayerBox} from '../types/CompositionEditorAction';

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

/**
 * Keeps a layer box inside the canvas with integer px and a minimum size. Layers larger than the
 * canvas are shrunk to fit, so a box never overflows the rendered PNG.
 */
export const clampLayerToCanvas = (
  box: LayerBox,
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>
): LayerBox => {
  const width = clamp(Math.round(box.width), compositionEditorLimits.minLayerSize, canvas.width);
  const height = clamp(Math.round(box.height), compositionEditorLimits.minLayerSize, canvas.height);
  const x = clamp(Math.round(box.x), 0, canvas.width - width);
  const y = clamp(Math.round(box.y), 0, canvas.height - height);

  return {x, y, width, height};
};
